const FormatHelper = (function () {
  return {
    formatDecimal: formatDecimal
  }

  /**
   * Return float with desired number of decimals
   * @param {Integer} number
   * @param {Integer} decimals
   * @return {Float}
   */
  function formatDecimal (number, decimals = 2) {
    let miltiplier = Math.pow(10, decimals)
    return parseFloat(parseFloat(Math.round(number * miltiplier) / miltiplier).toFixed(decimals))
  }
}())

export default FormatHelper



// WEBPACK FOOTER //
// ./src/helpers/formats.js